export default __webpack_public_path__ + "static/media/about.392a5bed.jpg";